import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/customer-lifetime-value-calculator',
  component: () => import('../../routes/CustomerLifetimeValueCalculator.svelte'),
  card: {
    id: 'customer-lifetime-value-calculator',
    title: 'Customer Lifetime Value (CLV)',
    description: 'Estimate the total revenue a customer generates over their entire relationship with your business.',
    icon: 'people',
    iconBgClass: 'bg-violet-50',
    iconTextClass: 'text-violet-600',
    href: '/customer-lifetime-value-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Customer Lifetime Value (CLV) Calculator – Free CLV Estimator',
    description: 'Free customer lifetime value calculator. Estimate total revenue per customer, net CLV after acquisition costs, and discounted present value of future customer revenue.',
  },
};

export default meta;
